// extracted by mini-css-extract-plugin
export var icon = "_x2-0";